import React from 'react';
import { LOGraph } from './features/LOGraph';

function App() {
  return (
    <LOGraph />
  );
}

export default App;
